<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑彩信模板' : '新增彩信模板'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="业务" prop="code" :error="errors.code">
                        <Cascade ref="cascade" v-model="form.code" @change="loadGroup"></Cascade>
                    </el-form-item>
                    <el-form-item label="名称" prop="name" :error="errors.name">
                        <el-input v-model="form.name" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="分組" prop="groupId">
                        <RemoteSelect v-model="form.groupId" :options="groups" value-name="id" label-name="name"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="标题" prop="title" :error="errors.title">
                        <el-input v-model="form.title" maxlength="15" show-word-limit></el-input>
                    </el-form-item>
<!--                    <el-form-item label="模板类型" prop="type" :error="errors.type">-->
<!--                        <el-select v-model="form.type" placeholder="请选择">-->
<!--                            <el-option label="静态模板" value="1"></el-option>-->
<!--                            <el-option label="动态模板" value="2"></el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-collapse v-model="activeFrame" accordion>
                        <el-collapse-item v-for="(frame, i) in frames" :key="i" :name="i">
                            <template #title>
                                {{'第' + (i + 1) + '帧'}}
                                <div @click.stop="removeFrame(i)" style="margin-left: 10px">
                                    <i class="el-icon-delete"></i>删除
                                </div>
                            </template>

                            <el-form-item :label="getFrameLabel(key)" v-for="(value, key) in frame" :key="key">
                                <template v-if="key === 'dur'">
                                    <el-input-number v-model="value.content" controls-position="right" :min="1" :max="60"></el-input-number>&nbsp;&nbsp;秒
                                </template>
                                <template v-else-if="key === 'text'">
                                    <el-row>
                                        <el-col :span="20">
                                            <el-input type="textarea" v-model="value.content" :rows="5" maxlength="500" show-word-limit></el-input>
                                            <el-checkbox v-model="unsubscribe" @change="changeUnsubscribe">退订</el-checkbox>
                                          <div style="color: red;">
                                            <b>根据工信部要求：短信内容中，回复退订“T”或“TD”等退订格式，统一改为使用“拒收请回复R”</b><br>
                                            <b>示例：短信息正文内容，拒收请回复R</b><br>
                                          </div>
<!--                                            <div class="help-text" v-if="form.type === '2'">-->
                                            <div class="help-text">
                                              变量占位符格式为：[[name]]<br>
                                              举例说明：尊敬的<strong>[[姓名]]</strong>，您的会员将于<strong>[[日期]]</strong>到期。<br>
                                              <p>注意：变量个数不要超过10个，变量名称不能重复。</p>
                                            </div>
                                        </el-col>
                                        <el-col :span="4" style="text-align: right">
                                            <el-link icon="el-icon-delete" :underline="false" @click="removeFrameItem(i, 'text')">删除</el-link>
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else-if="key === 'img'">
                                    <el-row>
                                        <el-col :span="20">
                                            <el-upload :action="$utils.getApiPath('/mms/template/upload')"
                                                       list-type="picture" :headers="headers"
                                                       :file-list="value.content"
                                                       :limit="1" accept=".jpg,.gif"
                                                       :on-success="uploadSuccess">
                                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                                <div slot="tip" class="el-upload__tip">只能上传jpg/gif文件</div>
                                            </el-upload>
                                        </el-col>
                                        <el-col :span="4" style="text-align: right">
                                            <el-link icon="el-icon-delete" :underline="false" @click="removeFrameItem(i, 'img')">删除</el-link>
                                        </el-col>
                                    </el-row>
                                </template>
                            </el-form-item>
                        </el-collapse-item>
                    </el-collapse>
                    <div style="color: red;margin-top: 20px" v-if="form.used">
                        <b>该模板已被使用，不可再次编辑！</b>
                    </div>
                    <template v-else>
                        <div style="color: red;margin-top: 10px;padding-left: 100px">
                          提示：<br>
                          1、总内容大小不可超过86KB。<br>
                          2、因最新政策调整，电信运营商每次提交模板需要审核才能下发，如遇测试延迟，请联系客户经理<br>
                          3、如文案中有链接，根据电信政策要求，必须在链接前加上http://或https://；否则会审核拒绝。
                        </div>
                        <el-form-item style="margin-top: 20px">
                            <el-dropdown @command="add" style="margin-right: 50px">
                                <el-button type="success">
                                    添加<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="frame">帧</el-dropdown-item>
                                    <el-dropdown-item command="text">文本内容</el-dropdown-item>
                                    <el-dropdown-item command="img">图片</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-button @click="close">取消</el-button>
                            <el-button type="primary" @click="submit">提交</el-button>
                        </el-form-item>
                    </template>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Cascade from '@/components/Cascade'
import RemoteSelect from '@/components/RemoteSelect'

export default {
        components: {
            Cascade,
            RemoteSelect
        },
        props: ["id", "groupId"],
        data() {
            return {
                activeFrame: 0,
                headers: {
                    Authorization: this.$utils.getAuthToken(),
                },
                frames: [],
                form: {
                    id: this.id,
                    name: "",
                    groupId: 0,
                    title: "",
                    type: "1",
                    content: {},
                    status: {value: "pass"},
                    code: "",
                    used: false
                },
                rules: {
                    name: [
                        {required: true, message: "请填写模板名称"}
                    ],
                    title: [
                      {required: true, message: "请填写标题"},
                      {max: 15, message: "标题最大长度15个字符"},
                    ],
                    type: [
                        {required: true, message: "请选择模板类型"}
                    ],
                    code: [
                        {required: true, min: 6, message: "请选择业务"}
                    ],
                    groupId: [
                        {required: true, message: "请选择分组"}
                    ]
                },
                errors: {},
                unsubscribe: false,
                groups: []
            }
        },
        beforeMount() {
            if (this.form.id > 0) {
                this.$axios.get("/mms_template/get/" + this.form.id).then(result => {
                    result['content'] = JSON.parse(result['content']);
                    this.$utils.merge(this.form, result);
                    this.drawFrames();
                })
            }

            this.loadGroup(this.$root.code);
        },
        methods: {
            loadGroup(code) {
                this.form.groupId = 0;
                if (code && code.length > 5) {
                    this.$axios.post("/group/list", {
                        rules: [
                            {field: "type", value: "mms"},
                            {field: "code", value: code},
                        ]
                    }).then(data => {
                        this.groups = [{id:0, name: "默认"}].concat(data);
                        this.form.groupId = this.groupId;
                    });
                } else {
                    this.groups = [{id:0, name: "默认"}];
                }
            },
            drawFrames() {
                let frames = [];
                this.form.content['frames'].forEach(f => {
                    let frame = {};
                    if (f['text']) {
                        frame['text'] = {content: f['text']['content'], top: this.getRegionTop(f['text']['region'])};
                    }
                    if (f['img']) {
                        frame['img'] = {content: [{url: f['img']['content']}], top: this.getRegionTop(f['img']['region'])};
                    }

                    let keys = Object.keys(frame).sort((a, b) => {
                        return frame[a]['top'] - frame[b]['top'];
                    });

                    let orderedFrame = {'dur': {content: parseInt(f['dur'].replace("ms", "")) / 1000}};
                    keys.forEach(k => {
                        orderedFrame[k] = frame[k];
                    });

                    frames.push(orderedFrame);
                });

                this.frames = frames;
            },
            getRegionTop(regionId) {
                let top = 0;
                let regions = this.form.content['layout']['regions'];
                regions.forEach(region => {
                    if (region['id'] === regionId) {
                        top = region['top'];
                        return false;
                    }
                });
                return top;
            },
            add(command) {
                if ("frame" === command) {
                    if (this.frames.length > 4) {
                        return;
                    }

                    this.frames.push({dur: {content: 1}});
                    this.activeFrame = this.frames.length - 1;
                } else {
                    if (this.activeFrame === 0 && this.frames.length === 0) {
                        this.add("frame");
                    }
                    this.$set(this.frames[this.activeFrame], command , {content: command === "text" ? "" : []});
                }
            },
            getFrameLabel(key) {
                if (key === "dur") {
                    return "播放时间";
                } else if (key === "text") {
                    return "文本内容";
                } else if (key === "img") {
                    return "图片";
                } else {
                    return "";
                }
            },
            removeFrame(index) {
                if (this.frames.length > 1) {
                    this.frames.splice(index, 1);
                    this.activeFrame = index - 1;
                }
            },
            removeFrameItem(index, type) {
                this.$delete(this.frames[index], type);
            },
            uploadSuccess(response) {
                const content = this.frames[this.activeFrame]['img']['content'];
                if (content.length) {
                    content[0]['url'] = "/file/" + response['data'];
                } else {
                    content.push({"url": "/file/" + response['data']});
                }
            },
            submit() {
                let form = JSON.parse(JSON.stringify(this.form));
                let height = 600;
                let width = 600;
                let content = {
                    title: this.form.title,
                    layout: {regions: []},
                    frames: []
                };

                // let hasText = false;
                this.frames.forEach((frame, fi) => {
                    let dur = frame['dur'];
                    let json = {dur: dur['content'] * 1000 + "ms"};
                    delete frame['dur'];

                    let size = Object.keys(frame).length;
                    Object.keys(frame).forEach((key, ii) => {
                        let regionId = fi + "-" + ii;
                        let h = height / size;
                        content.layout.regions.push({id: regionId, height: h, width: width, top: h * ii, left: 0});

                        if (key === "img") {
                            let imgUrl = frame[key]["content"][0]['url'];
                            if (imgUrl) {
                                json[key] = {content: imgUrl, region: regionId};
                            }
                        } else {
                          // if (this.form.type === "2") {
                          //   hasText = true;
                          // }
                          json[key] = {content: frame[key]["content"], region: regionId};
                        }
                    });

                    frame['dur'] = dur;
                    content.frames.push(json);
                });
                form.content = JSON.stringify(content);

              form.type = form.content.indexOf("[[") >= 0 ? "2" : "1";

                // if (hasText && form.content.indexOf("[[") < 0) {
                //   this.$message.error("动态模板中的模板内容需包含占位符！");
                //   return;
                // }

                let url = this.form.id > 0 ? "/mms_template/edit" : "/mms_template/save";
                this.$utils.submit(this.$refs.form, url, form, () => {
                    this.$emit("close", true);
                }, (data) => {
                    this.errors = data;
                });
            },
            close() {
                this.$emit("close", false);
            },
            changeUnsubscribe() {
                let content = this.frames[this.activeFrame]['text']['content'];
                if (this.unsubscribe) {
                    content += "拒收请回复R";
                } else {
                    if (content && content.endsWith("拒收请回复R")) {
                        content = content.substring(0, content.indexOf("拒收请回复R"));
                    }
                }
                this.$set(this.frames[this.activeFrame]['text'], "content", content);
            }
        }
    }
</script>
<style scoped>
>>>.el-upload-list__item {
  transition: none !important;
}
</style>